module.exports = __webpack_public_path__ + "static/img/005.d4c8f1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/005.jpg
// module id = lo7F
// module chunks = 1